/* tslint:disable */
/* eslint-disable */
/**
 * EM2
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { FeedbackType } from '../apiModels';
// @ts-ignore
import { ForumFeedBackQuestionModel } from '../apiModels';
/**
 * ForumFeedbackQuestionsApi - axios parameter creator
 * @export
 */
export const ForumFeedbackQuestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the feedback questions
         * @param {FeedbackType} [feedBackType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackQuestionsGet: async (feedBackType?: FeedbackType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/feedback-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (feedBackType !== undefined) {
                localVarQueryParameter['feedBackType'] = feedBackType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForumFeedbackQuestionsApi - functional programming interface
 * @export
 */
export const ForumFeedbackQuestionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ForumFeedbackQuestionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets the feedback questions
         * @param {FeedbackType} [feedBackType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedbackQuestionsGet(feedBackType?: FeedbackType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ForumFeedBackQuestionModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feedbackQuestionsGet(feedBackType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ForumFeedbackQuestionsApi - factory interface
 * @export
 */
export const ForumFeedbackQuestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ForumFeedbackQuestionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets the feedback questions
         * @param {ForumFeedbackQuestionsApiFeedbackQuestionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackQuestionsGet(requestParameters: ForumFeedbackQuestionsApiFeedbackQuestionsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ForumFeedBackQuestionModel>> {
            return localVarFp.feedbackQuestionsGet(requestParameters.feedBackType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for feedbackQuestionsGet operation in ForumFeedbackQuestionsApi.
 * @export
 * @interface ForumFeedbackQuestionsApiFeedbackQuestionsGetRequest
 */
export interface ForumFeedbackQuestionsApiFeedbackQuestionsGetRequest {
    /**
     * 
     * @type {FeedbackType}
     * @memberof ForumFeedbackQuestionsApiFeedbackQuestionsGet
     */
    readonly feedBackType?: FeedbackType
}

/**
 * ForumFeedbackQuestionsApi - object-oriented interface
 * @export
 * @class ForumFeedbackQuestionsApi
 * @extends {BaseAPI}
 */
export class ForumFeedbackQuestionsApi extends BaseAPI {
    /**
     * 
     * @summary Gets the feedback questions
     * @param {ForumFeedbackQuestionsApiFeedbackQuestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumFeedbackQuestionsApi
     */
    public feedbackQuestionsGet(requestParameters: ForumFeedbackQuestionsApiFeedbackQuestionsGetRequest = {}, options?: AxiosRequestConfig) {
        return ForumFeedbackQuestionsApiFp(this.configuration).feedbackQuestionsGet(requestParameters.feedBackType, options).then((request) => request(this.axios, this.basePath));
    }
}

